<template>
  <div>
    <h2 class="Trio-form-title">Datos sobre vivienda</h2>
    <div class="Trio-form-group">
      <div class="Trio-form-item">
        <label for="occupancy" class="Trio-label">Ocupación</label>
        <v-select
          id="occupancy"
          v-model="occupancy"
          :options="OCCUPANCY_OPTIONS"
          :reduce="(occupancy) => occupancy.value"
          name="occupancy"
          label="label"
          :value="null"
          placeholder="Elige el tipo de ocupación"
        ></v-select>
      </div>
      <div class="Trio-form-item">
        <label for="province" class="Trio-label">Provincia</label>
        <v-select
          id="provinceId"
          v-model="provinceId"
          :options="locations"
          :reduce="(name) => name.province_id"
          name="province_id"
          label="name"
          :value="null"
          placeholder="Selecciona la provincia"
        ></v-select>
      </div>
    </div>
    <div class="Trio-form-group">
      <div class="Trio-form-item">
        <label for="price" class="Trio-label">Precio de la vivienda (€)</label>
        <input
          id="price"
          v-model="price"
          name="price"
          type="number"
          min="25000"
          max="900000"
          placeholder="Precio de la vivienda"
        />
        <div class="Trio-slider-rang">
          <vue-slider
            v-model="price"
            :min="25000"
            :max="900000"
            :interval="1000"
          ></vue-slider>
        </div>
      </div>
      <div class="Trio-form-item">
        <label for="amount_borrowed" class="Trio-label"
          >Cantidad a solicitar (€)</label
        >
        <input
          id="ammountBorrowed"
          v-model="ammountBorrowed"
          name="ammountBorrowed"
          type="number"
          min="25000"
          max="900000"
          placeholder="Cantidad a solicitar"
        />
        <div class="Trio-slider-rang">
          <vue-slider
            v-model="ammountBorrowed"
            :min="25000"
            :max="900000"
            :interval="1000"
          ></vue-slider>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Store } from "../store/index";
import { OCCUPANCY_OPTIONS } from "../constants/occupancies";

export default {
  name: "personalForm",
  data() {
    return {
      OCCUPANCY_OPTIONS,
    };
  },
  computed: {
    locations: {
      get() {
        return Store.getters["locations/locations"] || [];
      },
    },
    provinceId: {
      get() {
        return Store.getters["mortgageData/provinceId"];
      },
      set(provinceId) {
        Store.commit("mortgageData/SET_PROVINCE_ID", provinceId);
      },
    },
    occupancy: {
      get() {
        return Store.getters["mortgageData/occupancy"];
      },
      set(occupancy) {
        Store.commit("mortgageData/SET_OCCUPANCY", occupancy);
      },
    },
    price: {
      get() {
        return Store.getters["mortgageData/price"];
      },
      set(price) {
        Store.commit("mortgageData/SET_PRICE", price);
      },
    },
    ammountBorrowed: {
      get() {
        return Store.getters["mortgageData/ammountBorrowed"];
      },
      set(ammountBorrowed) {
        Store.commit("mortgageData/SET_AMMOUNT_BORROWED", ammountBorrowed);
      },
    },
  },
};
</script>